export default (state = {}, action) => {
  switch (action.type) {
    case 'APPSTATUS':
      return action.payload;
    default:
      return state;
  }
};
